import { GetBackStoryQuery } from "@src/@types/api.d";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import Image from "next/image";
import React from "react";
import { motion } from "framer-motion";
import DialogModal from "@src/components/Dialog";
import { truncate } from "lodash";
import BackstoryModal from "@src/components/modals/BackstoryModal";
import { getRole } from "@src/utils/general";

interface Props {
  backStoryData: GetBackStoryQuery;
}

const Backstory = ({ backStoryData }: Props) => {
  return (backStoryData?.getBackStory ?? []).length > 0 ? (
    <section className="py-24 bg-[#EBE3CE]">
      <h2 className="text-[#4B4838] uppercase font-calabassas text-3xl lg:text-6xl mb-8 lg:mb-20 text-center">
        Our story
      </h2>
      <div className="grid grid-cols-1 px-10 md:px-40 py-2 pb-8 lg:grid-cols-2 gap-10 lg:gap-20">
        {backStoryData?.getBackStory?.map((story, idx) => (
          <div key={idx} className="flex flex-col gap-[1.56rem] items-center">
            <div
              key={idx}
              className="rounded-[18px] relative h-[300px] overflow-hidden w-full max-w-[400px] flex flex-col items-center justify-end gap-[1.57rem]"
            >
              <motion.div
                initial={{ scale: 1 }}
                animate={{
                  scale: 1.1,
                  transition: {
                    delay: 0.3,
                    duration: 0.8,
                    ease: [0.79, 0.14, 0.15, 0.86],
                  },
                }}
                className={
                  "relative top-0 bottom-0 right-0  left-0 w-full h-full after:absolute after:w-full after:h-full "
                }
              >
                <Image
                  placeholder="blur"
                  loading="eager"
                  layout="fill"
                  blurDataURL={`data:image/svg+xml;base64,${toBase64(
                    shimmer(700, 475)
                  )}`}
                  src={story?.image!}
                  alt={story?.title || "Wedding photo"}
                  className="object-contain object-center"
                />
              </motion.div>
            </div>
            <h4 className="text-[#4B4838] font-bold text-[1.3125rem] tracking-[0.02625rem] font-neue uppercase">
              {story?.title || "Our Story"}
            </h4>
            <p className="max-w-[30rem] tex-[0.75rem] md:text-4 text-justify text-[#4B4838] font-neue">
              {truncate(story?.story, {
                length: 300,
              })}
            </p>
            <p className="text-[#4B4838] font-bold text-sm tracking-[0.02625rem] font-neue uppercase">
              {getRole(story?.role)}
            </p>
            <DialogModal
              trigger={
                <button className="py-[0.25rem] font-neue uppercase text-[#4B4838] border-solid  px-4 !border-[1.5px] !border-[#4B4838] rounded-[0.875rem] tracking-wide hover:scale-105 transition-transform duration-200">
                  Continue Reading
                </button>
              }
            >
              <BackstoryModal
                title={story?.title ?? ""}
                story={story?.story ?? ""}
                role={getRole(story?.role) ?? ""}
              />
            </DialogModal>
          </div>
        ))}
      </div>
    </section>
  ) : (
    <></>
  );
};

export default Backstory;
